// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { AddToCartReadyToGoRingNewCustomerResponseFragmentDoc } from '../fragments/addToCartReadyToGoRingNewCustomerResponse.fragment.generated';
import { AddToCartReadyToGoRingSuccessNewCustomerFragmentDoc } from '../fragments/success/addToCartReadyToGoRingSuccessNewCustomer.fragment.generated';
import { CustomerRegistrationResponseFragmentDoc } from '../../../auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../../fragments/costumerConsultant.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartReadyToGoRingNewCustomerDocument = `
    mutation addToCartReadyToGoRingNewCustomer($input: AddToCartReadyToGoRingInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  addToCartReadyToGoRingNewCustomer(input: $input, customer: $customer) {
    ...addToCartReadyToGoRingNewCustomerResponse
  }
}
    ${AddToCartReadyToGoRingNewCustomerResponseFragmentDoc}
${AddToCartReadyToGoRingSuccessNewCustomerFragmentDoc}
${CustomerRegistrationResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}`;

export function useAddToCartReadyToGoRingNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartReadyToGoRingNewCustomerMutation, SchemaTypes.AddToCartReadyToGoRingNewCustomerMutationVariables>(AddToCartReadyToGoRingNewCustomerDocument);
};